import { QuoteException } from '@/domain/stripe/quote/exception/QuoteException'

export class NoQuoteFoundForOrganizationException extends  QuoteException {

}